import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[ldwAutofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {
  private element = inject<ElementRef<HTMLInputElement>>(ElementRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.element?.nativeElement.focus();
    },0)
  }
}
